/**
 * <s-footer-height> — placed inside the sticky reveal footer. Publishes the footer's
 * height as --footer-h on the footer so config/styles.css can let a footer taller
 * than the screen stop 1.5rem below the top edge: its whole content stays readable.
 */
class SFooterHeight extends HTMLElement {
  #observer;

  connectedCallback() {
    const footer = this.closest('footer');
    if (!footer) return;
    this.#observer = new ResizeObserver(() => {
      footer.style.setProperty('--footer-h', `${footer.offsetHeight}px`);
    });
    this.#observer.observe(footer);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

customElements.define('s-footer-height', SFooterHeight);
